export const messages: any = {
  validation: {
    required: 'Este campo é obrigatório.',
    minlength: 'O campo não atingiu o mínimo de caracteres.',
    maxlength: 'O campo excedeu o máximo de caracteres.',
    apiError: 'Erro ao processar a solicitação. Por favor, tente novamente mais tarde.',
    valorNaLista: 'Valor inválido. Selecione uma opção da lista disponível.',
    mask: 'O valor inserido não corresponde ao formato esperado.',
    min: 'O valor excedeu o mínimo permitido.',
    max: 'O valor excedeu o máximo permitido.',
    email: 'Digite um endereço de e-mail válido.',
    pattern: 'O formato do campo é inválido. Por favor, siga o padrão especificado.',
    birthdate: 'A data de nascimento não pode ser posterior a data atual e anterior a 100 anos atrás.',
    startDateInvalid:'A data de início não pode ser anterior a hoje.',
    endDateInvalid:'Data de finalização não pode ser anterior a de inicio',
    startDateSubscriptionInvalid:'Data de inicio das inscricões devem anteceder o inicio do evento',
    endDateSubscriptionInvalid:'Data de finalização das inscricões devem anteceder o inicio do evento',
    endDateSubscriptionAfterBlock:'Data deve ser posterior a data de inicio do período de inscrições do bloco',
    blockDateInvalid:'Data fora do periodo do evento',
    competitionDateInvalid:'Data fora do perido do bloco selecionado',
    blockEndDateInvalid:'Data deve ser posterior a data de inicio do bloco',
    blockDateLimitAttachemnt1:'Data limite de anexo da ficha de inscricão deve ser superior ou igual a data fim do periodo de inscricoes',
    blockDateLimitAttachemnt2: 'Data limite de anexo da ficha de inscricão deve anteceder a data fim do bloco',
    endYearMin: 'O ano final não pode ser menor que o ano de inicio',
    endYearMax: ' O ano final não poder ser maior que o ano atual'
  }
}
